export function calculateBarCapacity(zones) {
  return (Array.isArray(zones) ? zones : []).reduce(
    (sum, zone) =>
      sum + Number(zone.tableCount || 0) * Number(zone.tableCapacity || 4),
    0,
  );
}
